import { Check, CheckCheck } from "lucide-react";
import { cn } from "@/lib/utils";

type ReceiptStatus = "sending" | "sent" | "delivered" | "read";

interface ReadReceiptIndicatorProps {
  status: ReceiptStatus;
  className?: string;
}

export function ReadReceiptIndicator({ status, className }: ReadReceiptIndicatorProps) {
  if (status === "sending") {
    return (
      <div className={cn("h-4 w-4 rounded-full border border-current opacity-50", className)} />
    );
  }

  if (status === "sent") {
    return <Check className={cn("h-4 w-4 opacity-50", className)} />;
  }

  if (status === "delivered") {
    return <CheckCheck className={cn("h-4 w-4 opacity-70", className)} />;
  }

  // read - blue double check (Signal-style)
  return <CheckCheck className={cn("h-4 w-4 text-secondary", className)} />;
}
